import config from "../config";

export async function fetchSupportedDevices(backendFetch) {
    const response = await backendFetch(config.REACT_APP_HOST + "/api/v2/devices/supported")
    return await response.json();
}